import { selectors as globalSelectors } from 'global-reducer'
import {
  computePercent,
  deriveCompletedSections,
  getSections,
  setStoredProfileCompletion,
} from './profile-completion-sections'

function isComplete(percent) {
  return percent === 100
}

function currentSchoolYearIdFromStore() {
  const state =
    typeof window !== 'undefined' && window.store && window.store.getState
      ? window.store.getState()
      : null
  if (!state) return null
  const currentSchoolYear = globalSelectors.currentSchoolYear(state)
  return currentSchoolYear ? currentSchoolYear.id : null
}

export default function syncProfileCompletion({
  artist,
  previousArtist,
  community,
  updateArtistBadge,
  currentSchoolYearId,
}) {
  if (!community || !community.teachingArtistProfileCompletionEnabled)
    return Promise.resolve()
  if (!artist) return Promise.resolve()

  const options = {
    currentSchoolYearId:
      currentSchoolYearId != null
        ? currentSchoolYearId
        : currentSchoolYearIdFromStore(),
  }

  const sections = getSections()
  const completedSections = deriveCompletedSections(artist, options).filter(
    (sectionKey) => sections.includes(sectionKey)
  )
  const percent = computePercent(completedSections.length, sections.length)

  setStoredProfileCompletion(artist.id, {
    sectionsCompleted: completedSections,
    percentCompletion: percent,
  })

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('artist-profile-completion-updated'))
  }

  const previousCompletedCount = previousArtist
    ? deriveCompletedSections(previousArtist, options).filter((sectionKey) =>
        sections.includes(sectionKey)
      ).length
    : completedSections.length
  const previousPercent = computePercent(
    previousCompletedCount,
    sections.length
  )
  const didCompletionStateChange =
    isComplete(previousPercent) !== isComplete(percent)

  if (didCompletionStateChange && typeof updateArtistBadge === 'function') {
    return Promise.resolve(
      updateArtistBadge({
        taProfile: isComplete(percent),
      })
    ).catch(() => Promise.resolve())
  }

  return Promise.resolve()
}
